import React from 'react';
import { FileClock } from 'lucide-react';
import styles from './Dashboard.module.css';

export default function Reports() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Reports</h1>
        <p className={styles.pageSubtitle}>Download your monthly analytics and performance reports.</p>
      </div>

      <div className={styles.card} style={{ textAlign: 'center', padding: '64px 24px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ marginBottom: '24px' }}>
          <FileClock size={64} strokeWidth={1} className="text-accent" />
        </div>
        <h2 className={styles.cardTitle}>Report Generation in Progress</h2>
        <p style={{ color: 'var(--text2)', maxWidth: '400px', margin: '0 auto 24px', lineHeight: '1.6' }}>
          Your monthly report is being generated. It will be available for download here by the 1st of each month.
        </p>
        <button className="btn btn-outline" disabled style={{ opacity: 0.5, cursor: 'not-allowed' }}>
          Download PDF
        </button>
      </div>
    </div>
  );
}
